/* IMPORTS
	You can import directly from node_modules here.
*/
import $ from 'jQuery';
// import 'what-input';

/*
	LIBRARY IMPORTS
	Utilities, plugins, and behaviors that aren't tied to a specific component.
*/
import anchorLinks from './libraries/anchor-links';
import linkContainer from './libraries/link-container';
import './libraries/filters';
import './libraries/hoverintent.min.js';
import './libraries/what-input.js';
import './libraries/slick.min.js';
import './libraries/aos.js';

/*
	COMPONENT IMPORTS
	For specific components.
*/
import './components/cookies';
import './components/oembed';
import './components/fuoc';
import './components/external-link.js';
import './components/header-functions';
import './components/main-menu';
import './components/scrollable-list';
import './components/color-mode-toggle';
import './components/accessibility';
// import './components/blocks-previewer';
import popup from './components/pop-up';
import setupTabs from './components/tabs';
import footerBGColorMatcher from './components/footer-bg-color';
import oEmbed from './components/oembed';
import loadMore from './components/load-more';
import modal from './components/modal';
import modalPeople from './components/modal-people-card';
import modalGeneric from './components/modal-generic';
import modalFeatureLarge from './components/modal-feature-large';
import blockSpacing from './components/dynamic-block-spacing';

/*
	BLOCK IMPORTS
	For specific blocks.
*/
import heroHomepage from '../blocks/hero-homepage/js/hero-homepage';
import heroDefault from '../blocks/hero-default/js/hero-default';
import honoreeSpotlight from '../blocks/honoree-spotlight/js/honoree-spotlight';
import carouselHomepage from '../blocks/carousel-homepage/js/carousel-homepage';
import imageGallery from '../blocks/image-gallery/js/image-gallery';
import carouselCTA from '../blocks/carousel-cta/js/carousel-cta';
import sliderBlock from '../blocks/slider/js/slider';
import accordions from './components/accordions';
import sponsorsSlider from '../blocks/sponsorship-feature/js/sponsorship-feature';

// Easy console access to jQuery through '$'
window.$ = $;

// INITIALIZATION
$(() => {
	$('body').addClass('document-ready');

	// Higher priority first, lower priority later
	anchorLinks();
	linkContainer();
	heroHomepage();
	heroDefault();
	honoreeSpotlight();
	footerBGColorMatcher();
	carouselHomepage();
	sponsorsSlider();
	imageGallery();
	carouselCTA();
	sliderBlock();
	setupTabs();
	modal();
	popup();
	accordions();
	oEmbed();
	loadMore();
	modal();
	modalPeople();
	modalGeneric();
	modalFeatureLarge();
	blockSpacing();
	// stripHtmlComments();
	// lazyLoadPeopleCards();
});
